import {
	RadioButton as PaperRadioButton,
	type RadioButtonProps,
} from "react-native-paper";
import Box from "./Box";
export const Radio = ({ ...props }: RadioButtonProps) => {
	return (
		<Box style={{ opacity: props.disabled ? 0.38 : 1, position: "relative" }}>
			<PaperRadioButton.Android
				{...props}
				style={{ zIndex: 1 }}
				disabled={false}
			/>
			{props.disabled && (
				<Box
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						justifyContent: "center",
						alignItems: "center",
						zIndex: 10000,
						backgroundColor: "transparent",
					}}
				/>
			)}
		</Box>
	);
};
